/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// Radio de micro:bit: solo genera JavaScript, no tiene equivalente Arduino.

Blockly.Blocks.radio_set_group = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('GROUP')
      .setCheck(Number)
      .appendField(Blockly.Msg.LANG_RADIO_SET_GROUP);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RADIO_SET_GROUP_TOOLTIP);
  },
};

Blockly.Blocks.radio_send_number = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('NUMBER')
      .setCheck(Number)
      .appendField(Blockly.Msg.LANG_RADIO_SEND_NUMBER);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_RADIO_SEND_NUMBER_2);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RADIO_SEND_NUMBER_TOOLTIP);
  },
};

Blockly.Blocks.radio_send_string = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('STRING')
      .appendField(Blockly.Msg.LANG_RADIO_SEND_STRING);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_RADIO_SEND_STRING_2);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RADIO_SEND_STRING_TOOLTIP);
  },
};

Blockly.Blocks.radio_send_number_label = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('NUMBER')
      .setCheck(Number)
      .appendField(Blockly.Msg.LANG_RADIO_SEND_LABEL_NUMBER);
    this.appendValueInput('LABEL')
      .appendField(Blockly.Msg.LANG_RADIO_SEND_LABEL_LABEL);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_RADIO_SEND_LABEL_2);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RADIO_SEND_LABEL_TOOLTIP);
  },
};

Blockly.Blocks.radio_on_received_data = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_RADIO_ON_RECEIVED_DATA)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_NUMBER, 'number'],
        [Blockly.Msg.LANG_STRING, 'string'],
        [Blockly.Msg.LANG_NUMBER_LABEL, 'number_label'],
      ]), 'TYPE')
      .appendField(Blockly.Msg.LANG_RADIO_ON_RECEIVED_DATA_2);
    this.appendStatementInput('DO');
    this.setTooltip(Blockly.Msg.LANG_RADIO_ON_RECEIVED_DATA_TOOLTIP);
  },
};

// Los tres lectores sólo tienen sentido dentro de radio_on_received_data:
// devuelven los parámetros del callback que ese bloque abre.
Blockly.Blocks.radio_read_number = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_RADIO_READ_NUMBER);
    this.setTooltip(Blockly.Msg.LANG_RADIO_READ_NUMBER_TOOLTIP);
  },
};

Blockly.Blocks.radio_read_string = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, String);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_RADIO_READ_STRING);
    this.setTooltip(Blockly.Msg.LANG_RADIO_READ_STRING_TOOLTIP);
  },
};

Blockly.Blocks.radio_read_label = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, String);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_RADIO_READ_LABEL);
    this.setTooltip(Blockly.Msg.LANG_RADIO_READ_LABEL_TOOLTIP);
  },
};
